import { MapViewerService, Viewer3dService } from "@3ddv/ngx-dvm-internal";
import { InjectionToken, Provider } from "@angular/core";

export const VIEWER:    InjectionToken<MapViewerService>  = new InjectionToken<MapViewerService>('viewer');
export const MINIMAP:   InjectionToken<MapViewerService>  = new InjectionToken<MapViewerService>('minimap');
export const VIEWER3D:  InjectionToken<Viewer3dService>   = new InjectionToken<Viewer3dService>('viewer3d');

export const ViewerProvider:    Provider = {
    provide:    VIEWER,
    useClass:   MapViewerService
}

export const MinimapProvider:   Provider = {
    provide:    MINIMAP,
    useClass:   MapViewerService
}

export const Viewer3dProvider:  Provider = {
    provide:    VIEWER3D,
    useClass:   Viewer3dService
}
